import { Component } from '@angular/core';
import { Settings } from '../../data/Settings';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

    readonly Settings = Settings;
}
